import React from 'react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer>
      <div className="container">
        <div className="footer-brand">
          <img
            src={process.env.PUBLIC_URL + "/darklogo.svg"}
            alt="Ilmium"
            width="66"
            height="26"
          />
        </div>
        <div className="footer-meta">
          © {currentYear} Ilmium — All rights reserved.
        </div>
      </div>
    </footer>
  );
};

export default Footer;
